import { FormattedMessage } from "react-intl";
import { Table, TableCell, TableHeader, TableRow } from "~/components/ui/table";

export const ArchivedDocumentsListHeader = () => {
  return (
    <Table>
      <TableHeader>
        <TableRow className="text-zinc-500 !text-sm !font-medium leading-tight w-full grid grid-cols-12 gap-4">
          <TableCell className="py-4 font-medium col-span-4">
            <FormattedMessage id="documentsList.name" />
          </TableCell>
          <TableCell className="py-4 col-span-2">
            <FormattedMessage id="case" defaultMessage="Case" />
          </TableCell>
          <TableCell className="py-4 col-span-1">
            <FormattedMessage id="documentsList.size" />
          </TableCell>
          <TableCell className="py-4 col-span-2">
            <FormattedMessage id="documentsList.archivedAt" />
          </TableCell>
          <TableCell className="py-4 col-span-2">
            <FormattedMessage id="documentsList.archivedBy" />
          </TableCell>
          <TableCell className="py-4 text-right col-span-1" />
        </TableRow>
      </TableHeader>
    </Table>
  );
};
